import { connect } from 'react-redux';
import { change } from 'redux-form';
import actions from 'actions/Favorites';
import { FAVORITES_FORM } from 'constants/Favorites';
import { defineMessages, injectIntl } from 'react-intl';
import { setPillNotificationWithTimeout } from 'actions/Notification';
import { searchSelectors, apiActions as nucleusApiActions } from '@lifesize/nucleus';
import FavoritesSearch from 'components/Favorites/FavoritesSearch';
import _get from 'lodash/get';

const messages = defineMessages({
  addFavorite: {
    id: 'components.favorite.favoriteAdded',
    defaultMessage: '{name} added as a favorite!'
  }
});

const mapDispatchToProps = (dispatch, { intl }) => ({
  handleSelectContact: (contact) => {
    dispatch(change(FAVORITES_FORM, 'favoritesSearchBar', ''));
    dispatch(nucleusApiActions.contactSetFavorite(contact.id, true));
    dispatch(actions.setFormFocus(false));
    dispatch(setPillNotificationWithTimeout(intl.formatMessage(messages.addFavorite, { name: contact.name })));
  },
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    dispatch(change(FAVORITES_FORM, 'favoritesSearchBar', ''));
    dispatch(nucleusApiActions.contactSetFavorite(selectedContact.id, true));
    dispatch(actions.setFormFocus(false));
    dispatch(setPillNotificationWithTimeout(intl.formatMessage(messages.addFavorite, { name: selectedContact.name })));
  }
});

function getMaxItems(searchResults) {
  const resultLength = searchResults.length || 1;
  return Math.min(resultLength, 6);
}

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.favoritesSearch.values.favoritesSearchBar');
  const isFocused = _get(state, 'app.favorites.isFocused');
  const searchResults = searchSelectors.searchNonFavorites(state);
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const selectedContact = _get(searchResults[selectionIndex], 'contact');

  return {
    searchResults,
    searchString,
    maxItems: getMaxItems(searchResults),
    isFocused,
    selectedContact
  };
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FavoritesSearch));
